"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeviceByProductCode = void 0;
require("core-js/modules/es.object.assign.js");
var _react = _interopRequireWildcard(require("react"));
var _useHandleActionDevice = _interopRequireDefault(require("../../../hooks/useHandleActionDevice"));
var _useGetDeviceModelByProductCode = require("../../../hooks/useGetDeviceModelByProductCode");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const DeviceByProductCode = _ref => {
  let {
    thingPDIDDevice = null,
    requiredType = '',
    anywayShow = false,
    // only with requiredType
    modelProps = {} // { [type]: {...}, null: { /* for props to all types of models */}}
  } = _ref;
  const {
    handleClick,
    handlePointerOut,
    handlePointerOver,
    handlePointerMissed
  } = (0, _useHandleActionDevice.default)({
    thingPDIDDevice
  });
  const {
    model: DeviceModel,
    version,
    type
  } = (0, _useGetDeviceModelByProductCode.useGetDeviceModelByProductCode)({
    thingPDIDDevice,
    requiredType,
    anywayShow
  });
  return (0, _react.useMemo)(() => {
    var _modelProps$type;
    return /*#__PURE__*/_react.default.createElement("group", null, DeviceModel && /*#__PURE__*/_react.default.createElement(DeviceModel, _extends({
      onClick: v => thingPDIDDevice ? handleClick(v) : null,
      onPointerMissed: v => thingPDIDDevice ? handlePointerMissed(v) : null,
      onPointerOver: v => thingPDIDDevice ? handlePointerOver(v) : null,
      onPointerOut: () => thingPDIDDevice ? handlePointerOut() : null,
      thingPDIDDevice: thingPDIDDevice
    }, modelProps.null, ((_modelProps$type = modelProps[type]) === null || _modelProps$type === void 0 ? void 0 : _modelProps$type[version]) || modelProps[type])));
  }, [thingPDIDDevice, handleClick, handlePointerOut, handlePointerOver, handlePointerMissed, modelProps]);
};
exports.DeviceByProductCode = DeviceByProductCode;